// 代码执行

import type { RunCodeActionConfig } from '@lighthouse/shared'
import React, { useMemo } from 'react'

import * as CM from '../styles'
import * as SC from './styles'

type CodeExecuteCardProps = {
    config: RunCodeActionConfig
}

const CodeExecuteCard = ({ config }: CodeExecuteCardProps) => {
    const { inputVariables } = config
    if (!inputVariables || inputVariables.length === 0) {
        return null
    }
    return (
        <CM.CardItemContainer>
            <SC.TypeName>输入变量</SC.TypeName>
            <CM.FieldList>
                {inputVariables.map(item => (
                    <CM.FieldItem key={item.id}>
                        <CM.FieldItemTitle>{item.name}</CM.FieldItemTitle>
                    </CM.FieldItem>
                ))}
            </CM.FieldList>
        </CM.CardItemContainer>
    )
}

export default CodeExecuteCard
